import PropTypes from 'prop-types';

import SimplePageTemplate from '@spotahome/landings-common/src/components/SimplePageTemplate';

import InstitutionsCities from './InstitutionsCities';

function indexInstitutionsByCity(institutions) {
  const cities = {};

  Object.keys(institutions).forEach(institutionId => {
    const { city } = institutions[institutionId];

    if (!cities[city]) {
      cities[city] = [];
    }

    cities[city].push(institutions[institutionId]);
  });

  return cities;
}

const InstitutionsList = props => {
  const { institutions } = props;

  const institutionsByCity = indexInstitutionsByCity(institutions);

  return (
    <SimplePageTemplate title="Institutions">
      <InstitutionsCities institutionsByCity={institutionsByCity} />
    </SimplePageTemplate>
  );
};

InstitutionsList.defaultProps = {
  institutions: {}
};

InstitutionsList.propTypes = {
  institutions: PropTypes.object.isRequired
};

export default InstitutionsList;
